<template>
    <div class="product-cart-form">
      <div class="product-action">
        <div class="product__price" v-if="!cartMode">{{ product.price }} <span class="product__price--text">บาท</span></div>
        <a class="product-action__remove" @click.prevent="removeFromCart()" v-if="cartMode" href="#">ลบรายการ</a>

        <div class="product-action__qty" v-if="product.status == 1 && !isSoldout()">
          <div class="tooltip -maxQuantity" x-placement="top" aria-hidden="false" v-show="quantityTooltipEnabled">
            <div class="wrapper">
              <div class="tooltip-arrow"></div>
              <div class="tooltip-inner">
                จำกัดรายการไม่เกิน {{ product.maxQuantity }}
              </div>
            </div>
          </div>
          <i class="icon-help" v-show="product.maxQuantity > 0" @click="showQuantityTooltip"></i><label for="product-qty" class="product-action__label"> จำนวน</label>
          <input id="product-qty" class="product-action__input" type="number" min="1" inputmode="numeric" pattern="[0-9]*" required
                 ref="input"
                 :value="quantity"
                 v-on:blur="checkZeroValue"
                 v-on:keydown="validateKey"
                 v-on:input="updateValue($event.target.value)"
                 v-on:focus="selectAll">
          <div class="btn-spinner">
            <a class="btn-dec" @click.prevent="inc()">▲</a>
            <a class="btn-inc" @click.prevent="dec()">▼</a>
          </div>
        </div>
      </div>
    </div>
</template>

<script>

export default {
  name: 'ProductCartForm',
  props: {
    product: {
      type: Object,
      required: true
    },
    initialQuantity: {
      type: Number,
      required: true
    },
    cartMode: {
      type: Boolean,
      required: false
    },
    attributes: {
      type: Object,
      required: false
    }
  },
  data () {
    const quantity = Math.max(this.initialQuantity, 1)
    return {
      quantity: quantity,
      productAttributes: {},
      quantityTooltipEnabled: false,
      quantityTooltipTimer: null
    }
  },
  methods: {
    resetQuantity () {
      this.quantityTooltipEnabled = false
      this.quantity = 1
    },
    showQuantityTooltip () {
      if (this.quantityTooltipTimer) {
        clearTimeout(this.quantityTooltipTimer)
      }
      this.quantityTooltipEnabled = true
      this.quantityTooltipTimer = setTimeout(() => {
        this.quantityTooltipEnabled = false
      }, 3000)
    },
    checkValidMaxQuantity (quantity) {
      if (this.product.maxQuantity > -1 && quantity > this.product.maxQuantity) {
        this.showQuantityTooltip()
        return false
      }

      return true
    },
    inc () {
      if (!this.checkValidMaxQuantity(this.quantity + 1)) {
        return
      }

      this.quantityTooltipEnabled = false
      this.quantity += 1
    },
    dec () {
      this.quantityTooltipEnabled = false
      if (this.quantity > 1) {
        this.quantity -= 1
      }
    },
    removeFromCart () {
      this.$store.dispatch('removeFromCart', {
        product: this.product,
        attributes: this.attributes
      })
      this.$emit('itemRemoved', this.product, this.attributes, parseInt(this.quantity || 0))
      this.$utils.fbTrack('removeFromCart', this.quantity, { sku: this.product.sku })
    },
    validateKey (event) {
      const key = this.$utils.getEventKey(event)
      let allowedKeys = '0,1,2,3,4,5,6,7,8,9,Backspace,Tab,Enter,ArrowRight,Right,ArrowLeft,Left'.split(',')
      if (allowedKeys.indexOf(key) === -1) {
        event.preventDefault()
      }
    },
    updateValue (value) {
      let quantity = 0

      if (value) {
        let newValue = value.trim().replace(/[^0-9]/g, '')
        if (newValue !== '') {
          quantity = parseInt(newValue || 0, 10)
        }
      }

      if (quantity) {
        if (!this.checkValidMaxQuantity(quantity)) {
          return
        }

        this.quantity = quantity
        this.$refs.input.value = this.quantity
      } else {
        this.$refs.input.value = '0'
      }
    },
    checkZeroValue (event) {
      this.$refs.input.value = this.quantity
    },
    selectAll: function (event) {
      // Workaround for Safari bug
      // http://stackoverflow.com/questions/1269722/selecting-text-on-focus-using-jquery-not-working-in-safari-and-chrome
      setTimeout(function () {
        event.target.select()
      }, 0)
    },
    isSoldout () {
      return (this.product.flags & 1) || (this.product.notAfter && this.product.notAfter < (new Date()).getTime())
    }
  },
  watch: {
    quantity: function () {
      this.$emit('quantityChanged', this.product, this.attributes, parseInt(this.quantity || 0))
      this.$utils.fbTrack('updateProductQuantity', this.quantity, { sku: this.product.sku })
    }
  }
}
</script>

<style scoped lang="scss">
@import '../css/base/var';
@import '../css/base/mixins';
@import '../css/component/form';

$product-remove-color: #9D9D9D;

.-price {
    font-size: 1.8em;
    font-weight: 300;
}

.-quantity {
    input {
        text-align: center;
        width: 4em;
        padding: 4px 8px;
    }
}


.product-action {
  &__remove {
    font-size: em(14px);
    color: $product-remove-color;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}

/* Remove controls from Firefox */
input[type=number],
input[type=number]:hover {
    -moz-appearance: textfield;
}

/* Re-applies the controls on :hover and :focus */
input[type="number"]:hover,
input[type="number"]:focus {
    -moz-appearance: number-input;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.btn-dec, .btn-inc {
  outline: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  &:active {
    color: #715786;
  }
}

.icon-help {
  cursor: pointer;
}



// override

.tooltip {
  position: absolute;
  top: -3em;
  left: -50%;

  .tooltip-inner {
    white-space: nowrap;
  }
}
</style>



// WEBPACK FOOTER //
// ProductCartForm.vue?3cc6db81